/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import createMetaImagePath from 'utils/create-meta-image-path';
import MainContext from 'context/main';

const SEO = (props) => {
  const {
    title,
    metaDesc,
    metaKeywords,
    metaRobotsNoindex,
    opengraphDescription,
    opengraphTitle,
    opengraphImage,
    opengraphUrl,
    twitterTitle,
    twitterDescription,
    twitterImage,
    canonical,
    date,
  } = props;

  const {
    siteSettings: { settings, siteUrl },
  } = useContext(MainContext);

  const isRobotsNoindexPage = metaRobotsNoindex === 'noindex';
  const createdAt = date.createdAt && new Date(date.createdAt).toISOString().split('T')[0];
  const modifiedAt = date.modifiedAt && new Date(date.modifiedAt).toISOString().split('T')[0];
  return (
    <Helmet
      title={title}
      htmlAttributes={{
        lang: settings.language,
        prefix: 'og: http://ogp.me/ns#',
      }}
    >
      {/* General */}
      <meta name="description" content={metaDesc} />
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {isRobotsNoindexPage && <meta name="robots" content="noindex" />}
      {/* Open Graph */}
      <meta property="og:title" content={opengraphTitle} />
      <meta property="og:description" content={opengraphDescription} />
      <meta property="og:type" content="website" />
      {opengraphImage && (
        <meta property="og:image" content={createMetaImagePath(opengraphImage, siteUrl)} />
      )}
      {opengraphUrl?.startsWith(siteUrl) && <meta property="og:url" content={opengraphUrl} />}
      {/* Twitter */}
      <meta name="twitter:title" content={twitterTitle || title} />
      <meta name="twitter:description" content={twitterDescription || metaDesc} />
      {(twitterImage || opengraphImage) && (
        <meta
          property="twitter:image"
          content={createMetaImagePath(twitterImage || opengraphImage, siteUrl)}
        />
      )}
      {canonical?.startsWith(siteUrl) && <link rel="canonical" href={canonical} />}
      {/* <meta name="date.created" content="YYYY-MM-DD" /> */}
      {/* <meta name="date.modified" content="YYYY-MM-DD; YYYY-MM-DD" /> */}
      {date && (
        <script type="application/ld+json">
          {`
            {
                "@context": "https://schema.org",
                "headline": "${title}",
                ${createdAt ? `"datePublished": "${createdAt}",` : ''}
                ${modifiedAt ? `"dateModified": "${modifiedAt}"` : ''}
            }
          `}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
